// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1jUXu","content":"LoadingAlert_content__21K76"};